<template>
  <div class="alarms" v-loading.fullscreen.lock="loading">
    <div class="alarms-header">
      <div>
        <el-button class="alarms-header-search-btn" type="primary" @click="onCreateAlarm"
          >创建告警</el-button
        >
      </div>
      <div class="alarms-header-search">
        <el-input v-model="keywords" placeholder="请输入关键字" @keyup.enter.native="onSearch">
          <i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch"></i>
        </el-input>
      </div>
    </div>
    <div class="alarms-content">
      <el-table class="alarms-content-table" ref="table" :data="alarmList" stripe size="mini">
        <el-table-column prop="name" label="告警名称">
          <template #default="scope">
            <ellipsis-card :title="scope.row.name" :keyword="scope.row.name"></ellipsis-card>
          </template>
        </el-table-column>
        <el-table-column prop="openStatistics" label="是否启用">
          <template #default="scope">
            <el-switch
              v-model="scope.row.enabled"
              inactive-color="#C0C4CC"
              active-color="#00a0ff"
              @change="onIsEnable(scope.row)"
            >
            </el-switch>
            <span> {{ scope.row.enabled ? '已启用' : '已禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <!-- <el-button type="primary" @click="onClickDetail(scope.row.id)">详情</el-button> -->
            <el-button type="primary" @click="onEditAlarm(scope.row.id)">编辑</el-button>
            <el-button @click="onDeleteAlarm(scope.row)">删除</el-button>
          </template>
        </el-table-column>

        <div class="alarms-empty" slot="empty">
          <p class="alarms-empty-text">暂无告警</p>
          <img class="alarms-empty-icon" src="../../../assets/img/empty.png" />
        </div>
      </el-table>

      <el-pagination
        class="alarms-pagination"
        @current-change="handlePageChange"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <alarm-creator-and-editor
      ref="alarmCreatorAndEditor"
      @submit="handleAlarmCreatedAndEditor"
    ></alarm-creator-and-editor>
  </div>
</template>

<script>
import { reqFetchParseAlarmList, reqDestroyAlarm, reqUpdataAlarmEnable } from '../../../api/alarm';
import AlarmCreatorAndEditor from './components/AlarmCreatorAndEditor';
import EllipsisCard from '../common/EllipsisCard';

export default {
  name: 'AlarmIndex',

  components: {
    AlarmCreatorAndEditor,
    EllipsisCard
  },

  props: {
    logId: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    },
    logName: {
      type: String,
      default: ''
    },
    storeDbName: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      keywords: '',
      alarmList: [],
      pagination: {
        currentPage: 1,
        pageSize: 8,
        total: 0
      },
      ellipsisContentVisible: false
    };
  },

  watch: {
    logId: {
      immediate: true,
      handler: function() {
        this.getAlarmList();
      }
    }
  },

  methods: {
    //获取告警列表
    async getAlarmList() {
      try {
        this.loading = true;
        const params = {
          pageNo: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          logId: this.logId
        };
        if (this.keywords) {
          params.keyword = this.keywords;
        }
        const { data } = await reqFetchParseAlarmList(params);
        this.alarmList = data.alertDtoList.map(item => {
          item.enabled = !item.enabled;
          return item;
        });
        this.pagination.total = data.total;
      } finally {
        this.loading = false;
      }
    },
    //搜索
    onSearch() {
      this.pagination.currentPage = 1;
      this.getAlarmList();
    },

    //创建告警
    onCreateAlarm() {
      this.$refs.alarmCreatorAndEditor.open({
        logId: this.logId,
        logName: this.logName,
        projectId: this.projectId,
        storeDbName: this.storeDbName,
        drawerType: 'create'
      });
    },

    //编辑告警
    onEditAlarm(alertId) {
      this.$refs.alarmCreatorAndEditor.open({
        logId: this.logId,
        projectId: this.projectId,
        logName: this.logName,
        drawerType: 'edit',
        storeDbName: this.storeDbName,
        alertId: alertId
      });
    },

    //告警创建编辑成功后的回调
    handleAlarmCreatedAndEditor(drawerType, name) {
      drawerType === 'edit'
        ? this.$message.success('保存成功，约一分钟后生效')
        : this.$message.success({
            showClose: true,
            message: `告警: ${name} 创建成功，约一分钟后生效`
          });
      this.pagination.currentPage = 1;
      this.keywords = '';
      this.getAlarmList();
    },

    //详情
    // onClickDetail() {},

    //删除
    async onDeleteAlarm(data) {
      try {
        await this.$msgbox({
          title: `警告`,
          message: `确定要删除告警【${data.name}】吗？`,
          type: 'warning',
          showCancelButton: true,
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            this.loading = true;
            const message = await reqDestroyAlarm({ ids: data.id });
            if (message.code === 0) {
              this.$message.success('删除成功，约一分钟后生效');
              this.getAlarmList();
            } else {
              this.$message.error('删除失败');
            }
            done();
          }
        });
      } catch (e) {
        if (e === 'cancel') return;
      } finally {
        this.loading = false;
      }
    },

    //是否禁用
    async onIsEnable(row) {
      let parmas = {
        id: row.id,
        enabled: !row.enabled
      };
      await reqUpdataAlarmEnable(parmas);
      row.enabled
        ? this.$message.success('启用成功，约一分钟后生效')
        : this.$message.success({
            showClose: true,
            message: `禁用成功，约一分钟后生效`
          });
      this.getAlarmList();
    },

    //分页
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.getAlarmList();
    }
  }
};
</script>

<style lang="scss" scoped>
.alarms {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    &-area {
      margin-left: 10px;
    }

    &-search {
      display: flex;
      justify-content: space-between;

      .el-icon-search {
        cursor: pointer;
      }
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;

    &-table {
      width: 100%;
      flex: 1;
      overflow: auto;
    }
  }

  &-empty {
    flex: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-text {
      color: #999;
    }

    &-icon {
      margin: 50px 0;
    }
  }

  &-pagination {
    margin-top: 40px;
    text-align: center;
  }
}
</style>
